module.exports = __webpack_public_path__ + "static/media/info_side.ca156541.webp";